import { Component, OnInit, effect, inject, model } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IBaseEntityData } from '@core/interfaces/entity-request.interface';
import { EntityApiService } from '@core/services/entity-api.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MetaManagerService } from '@shared/services/meta-manager.service';
import { environment } from 'src/environments/environment';
import { AutonomousSellerDetailComponent } from '../../components/autonomous-seller-detail/autonomous-seller-detail.component';
import { StandardSellerComponent } from '../../components/seller/standard-seller.component';
import { SellerBrandingService } from '../../services/seller-branding.service';

@Component({
  selector: 'app-seller',
  standalone: true,
  imports: [StandardSellerComponent, AutonomousSellerDetailComponent],
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.scss'],
})
@UntilDestroy()
export class SellerComponent implements OnInit {
  public entityData = model<IBaseEntityData>();
  public isAutonomousSeller: boolean = false;
  private _route = inject(ActivatedRoute);
  private _entityCoreApiService = inject(EntityApiService);
  private _metaService = inject(MetaManagerService);
  private branding = inject(SellerBrandingService);

  constructor() {
    effect((onCleanup) => {
      onCleanup(() => {
        this.branding.clearBranding();
      });
    });
  }

  ngOnInit(): void {
    this._route.params.pipe(untilDestroyed(this)).subscribe((params) => {
      if (params['id']) {
        this.getEntityByPk(+params['id']);
      }
    });
  }

  private getEntityByPk(idEntity: number): void {
    this._entityCoreApiService
      .getLocalCachedBaseDataByPk(idEntity)
      .subscribe((entity) => {
        this.entityData.set(entity);
        this.isAutonomousSeller = entity.isAutonomous;
        if (this.isAutonomousSeller) {
          this.branding.applyBranding(entity);
        } else {
          this.branding.clearBranding();
        }

        this._metaService.updateTitleAndMeta(
          this.entityData().entityName,
          '',
          environment.APPOrigin + '/seller/' + this.entityData().idEntity,
          this.entityData().photoFullPath
        );
      });
  }
}
